import type { ENV } from "./types";

export const production: ENV = {
  STATIC_URL: "https://www.monta.ir/static",
  STRAPI_URL: "https://strapi.monta.ir",
  API_URL: "https://api.monta.ir",
  PAYMENT_GATEWAYS: {
    ASAN_PARDAKHT: "https://asan.shaparak.ir",
    SEP: "https://sep.shaparak.ir/OnlinePG/OnlinePG"
  },
  SERVLET_URL: "https://api.monta.ir/servlet",
  COOKIE_DOMAIN: ".monta.ir",

  LANDING_URL: "https://monta.ir",
  APPLICATION_URL: "https://app.monta.ir",
  PANEL_URL: "https://panel.monta.ir",
  LEGACY_APPLICATION_URL: "https://app.monta.ir/old",

  GWT_URL: "https://app.monta.ir/gwt",
  REGISTER_URL: "https://monta.ir/gwtsignup",
  EXAM_URL: "https://app.monta.ir/gwtexam"
};
